import {
    ISlideSizeService,
    ISlideSizeServiceDelegate,
    ISlideSizeConfigDialogProps } from '@src/slide/application/service/slide-size-service/index.interface';
import React from 'react';
import {
    SlideSizeConfigDialog,
} from '@src/slide/application/service/slide-size-service/core/slide-size-config-dialog';
import ReactDOM from 'react-dom';
import { observable } from 'mobx';
import { ScaleConfirmDialog } from '@src/slide/application/service/slide-size-service/core/scale-confirm-dialog';
import { STSlideSizeType } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import {
    DEFAULT_4_3_WIDTH,
    DEFAULT_16_9_WIDTH,
    DEFAULT_4_3_HEIGHT,
    DEFAULT_16_9_HEIGHT,
} from '@src/slide/application/service/slide-size-service/core/constants';

/**
 * 自定义比例设置
 */
export default class SlideSizeService implements ISlideSizeService {
    @observable public dialogVisible = false;
    @observable public confirmVisible = false;
    private dialogContainer = document.createElement('div');
    private slideSizeServiceDelegate: ISlideSizeServiceDelegate;

    public setDelegate = (props: ISlideSizeServiceDelegate) => {
        this.slideSizeServiceDelegate = props;
    };

    public showSlideSizeDialog = (props: ISlideSizeConfigDialogProps) => {
        this.dialogVisible = true;
        ReactDOM.render(<SlideSizeConfigDialog
            { ...props }
            slideSizeService={this}
            uiDataService={this.slideSizeServiceDelegate.uiDataService}
        />, this.dialogContainer);
    };

    public showSlideSizeConfirmDialog = async (type: STSlideSizeType): Promise<boolean> => (
        new Promise<boolean>((resolve) => {
            this.confirmVisible = true;
            const { slideWidth, slideHeight, slideSizeType } = this.getDefaultSize(type);
            ReactDOM.render(<ScaleConfirmDialog
                uiDataService={this.slideSizeServiceDelegate.uiDataService}
                slideSizeService={this}
                slideWidth={slideWidth}
                slideHeight={slideHeight}
                slideSizeType={slideSizeType}
                onSuccess={() => resolve(true)}
                onCancel={() => resolve(false)}
            />, this.dialogContainer);
        })
    );

    public hideDialog = () => {
        this.dialogVisible = false;
        this.confirmVisible = false;
        ReactDOM.unmountComponentAtNode(this.dialogContainer);
    };

    public getDefaultSize = (type: STSlideSizeType) => {
        switch (type) {
            case STSlideSizeType.screen4x3:
                return {
                    slideWidth: DEFAULT_4_3_WIDTH,
                    slideHeight: DEFAULT_4_3_HEIGHT,
                    slideSizeType: STSlideSizeType.screen4x3,
                };
            case STSlideSizeType.screen16x9:
                return {
                    slideWidth: DEFAULT_16_9_WIDTH,
                    slideHeight: DEFAULT_16_9_HEIGHT,
                    slideSizeType: STSlideSizeType.screen16x9,
                };
            default:
                return {
                    slideWidth: DEFAULT_16_9_WIDTH,
                    slideHeight: DEFAULT_16_9_HEIGHT,
                    slideSizeType: STSlideSizeType.screen16x9,
                };
        }
    };
}
